<template>
  <article class="media">
    <figure class="media-left">
      <font-awesome-icon :icon="['far', getIcon(item.type)]" size="2x" :class="getColor(item.type)" :spin="item.type == 'progress'" />
    </figure>
    <div class="media-content">
      <div class="content">
        <p>
          <router-link :to="`/${item.metadata.entityType}/${item.metadata.entityId}/overview`" v-if="item.metadata && item.metadata.entityId">{{item.label}}</router-link>
          <strong v-else>{{item.label}}</strong><br>
          <small>{{formatDistanceToNow(new Date(item.createdOn), { addSuffix: true })}}</small>
        </p>
      </div>
    </div>
  </article>
</template>
<script>
import { formatDistanceToNow } from 'date-fns';

export default {
  data() {
    return {
      formatDistanceToNow
    }
  },
  props: {
    item: Object
  },
  methods: {
    getIcon(type) {
      if (!type) return 'question-circle';
      switch (type.toLowerCase()) {
        case 'info':
          return 'info-circle';
        case 'warning':
          return 'exclamation-triangle';
        case 'error':
          return 'bomb';
        case 'success':
          return 'flag-checkered';
        case 'partialsuccess':
          return 'flag-checkered';
        default:
          return 'question-circle';
      }
    },
    getColor(type) {
      if (!type) return 'has-text-grey';
      switch (type.toLowerCase()) {
        case 'info':
          return 'has-text-info';
        case 'warning':
          return 'has-text-warning';
        case 'error':
          return 'has-text-danger';
        case 'success':
          return 'has-text-success';
        case 'partialsuccess':
          return 'has-text-warning';
        default:
          return 'has-text-grey';
      }
    },
    parseMetadataIntoUrl() {

    }
  }
}
</script>
